// removed by extract-text-webpack-plugin
module.exports = {"trackList":"zrZ4SJBEWcb0e3g7cDY_-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendForwardForm.scss
// module id = 1303
// module chunks = 1